import React, { createContext, useContext, useEffect, useState } from "react";
import { TaskStatusType, TaskType } from "../utils/enums";
import { getData } from "../utils/apiFunctions";
import { ApiEndpoints } from "../utils/common";

const StateContext = createContext();

const initialState = {
  userProfile: false,
  notification: false,
};

export const ContextProvider = ({ children }) => {
  const [activeMenu, setActiveMenu] = useState(true);
  const [isNewTenant, setIsNewTenant] = useState();
  const [isRegisteredInRmmi, setIsRegisteredInRmmi] = useState(false);
  const [isClicked, setisClicked] = useState(initialState);
  const [screenSize, setscreenSize] = useState(undefined);
  const [user, setUser] = useState();
  const [location, setLocation] = useState("");
  const [isOndemandInventoryTaskRunning, setIsOndemandInventoryTaskRunning] =
    useState(false);
  const [isOndemandAgentTaskRunning, setIsOndemandAgentTaskRunning] =
    useState(false);
  const [isRecurrentAgentTaskRunning, setIsRecurrentAgentTaskRunning] =
    useState(false);
  const [isRecurrentInventoryTaskRunning, setIsRecurrentInventoryTaskRunning] =
    useState(false);
  const [finishedOnDemandInventoryTask, setFinishedOnDemandInventoryTask] =
    useState();
  const [hasInventoryEvents, setHasInventoryEvents] = useState(false);
  const [hasAgentEvents, setHasAgentEvents] = useState(false);
  const [unhandledInventoryEvents, setUnhandledInventoryEvents] = useState(0);
  const [unhandledAgentEvents, setUnhandledAgentEvents] = useState(0);

  const handleClick = (clicked) => {
    setisClicked({ ...initialState, [clicked]: true });
  };

  const setTaskStatus = ({ taskStatusType, typeOfTask, isRecurrentTask }) => {
    if (taskStatusType === TaskStatusType.RUNNING) {
      if (typeOfTask === TaskType.INVENTORY && isRecurrentTask) {
        setIsRecurrentInventoryTaskRunning(true);
      } else if (typeOfTask === TaskType.INVENTORY && !isRecurrentTask) {
        setIsOndemandInventoryTaskRunning(true);
      }
      if (typeOfTask === TaskType.AGENT && isRecurrentTask) {
        setIsRecurrentAgentTaskRunning(true);
      } else if (typeOfTask === TaskType.AGENT && !isRecurrentTask) {
        setIsOndemandAgentTaskRunning(true);
      }
    }
    if (
      taskStatusType === TaskStatusType.SUCCEEDED ||
      taskStatusType === TaskStatusType.FAILED
    ) {
      if (typeOfTask === TaskType.INVENTORY && isRecurrentTask) {
        setIsRecurrentInventoryTaskRunning(false);
      } else if (typeOfTask === TaskType.INVENTORY && !isRecurrentTask) {
        setIsOndemandInventoryTaskRunning(false);
      }
      if (typeOfTask === TaskType.AGENT && isRecurrentTask) {
        setIsRecurrentAgentTaskRunning(false);
      } else if (typeOfTask === TaskType.AGENT && !isRecurrentTask) {
        setIsOndemandAgentTaskRunning(false);
      }
    }
  };

  useEffect(() => {
    const getUserInfo = async () => {
      const userData = await getData(`${ApiEndpoints.USER_INFO}`);

      setUser(userData);
      setIsRegisteredInRmmi(userData?.tenantInfo.isTenantRegisteredInRmmi);
    };

    getUserInfo().catch(console.error);
  }, [isRegisteredInRmmi]);

  return (
    <StateContext.Provider
      value={{
        activeMenu,
        setActiveMenu,
        isClicked,
        setisClicked,
        handleClick,
        screenSize,
        setscreenSize,
        isNewTenant,
        setIsNewTenant,
        user,
        setUser,
        location,
        setLocation,
        setTaskStatus,
        isOndemandInventoryTaskRunning,
        isOndemandAgentTaskRunning,
        isRecurrentAgentTaskRunning,
        isRecurrentInventoryTaskRunning,
        finishedOnDemandInventoryTask,
        setFinishedOnDemandInventoryTask,
        hasInventoryEvents,
        setHasInventoryEvents,
        unhandledInventoryEvents,
        setUnhandledInventoryEvents,
        hasAgentEvents,
        setHasAgentEvents,
        unhandledAgentEvents,
        setUnhandledAgentEvents,
        setIsRegisteredInRmmi,
        isRegisteredInRmmi,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
